export default {
  selectedPatchPath: null,
  filters: {
    deprecated: false,
    utility: false,
  },
  installingLibraries: [],
};



// WEBPACK FOOTER //
// ../../src/projectBrowser/state.js